export interface LoyaltyActionType {
  id: string;
  name: string;
  feature: string;
  ctaLink: string;
  annexActionId: string | number;
  countries: string;
}

export enum LoyaltyActionFeature {
  ENABLE_NOTIFICATIONS = 'ENABLE_NOTIFICATIONS',
  COMPLETE_WITB = 'COMPLETE_WITB',
  SYNC_USGA = 'SYNC_USGA',
  TRACK_ROUND = 'TRACK_ROUND',
  COMPLETE_QUIZ = 'COMPLETE_QUIZ',
  REGISTER_YOUR_CLUB = 'REGISTER_YOUR_CLUB',
  BIRTHDAY_GIFT = 'BIRTHDAY_GIFT',
  TRADE_IN_CLUB = 'TRADE_IN_CLUB',
  SIGNUP_NEWSLETTER = 'SIGNUP_NEWSLETTER',
}
